/* eslint-disable-next-line */
import React, {useEffect, lazy, Suspense} from "react";
import { useDispatch} from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import {update_device_data, auth_token_update} from './actions/action-creators/state-update';
//Css
import './assets/vendors/mdi/css/materialdesignicons.min.css';
import './assets/vendors/css/vendor.bundle.base.css';
import './assets/css/style.css?v=1';
import NotFound from './screens/404';
import {LoaderMedium} from './components/loader';
// const Home = lazy(() => import('./screens/home'));
import Dashboard from './screens/dashboard/main';
import StudentList from './screens/student/list';
import StudentPortfolio from './screens/student/portfolio';
import StuPinnedList from './screens/student/list-pinned';
import StudentAnalytics from './screens/student/analytics';
import FellowList from './screens/fellow/list';
//Subscription
import EnrollmentList  from './screens/subscription/enrollment-list';
//Affiliate
import AffiliateList from './screens/affiliate/list';
import AffiliatePendingList from './screens/affiliate/list-pending';
import AffiliateSettings from './screens/affiliate/settings';
//Nomination
import NominationList from './screens/school/nomination';
import HubList from './screens/hub/list';
import StakeholderList from './screens/stakeholder/list';
// Glosco
import GloscoRequestList from './screens/glosco/request-list';
import GloscoManageLevel from './screens/glosco/manage-level';
import GloscoGripSession from './screens/glosco/glosco-grip-session';
import GlobalConferenceSession from './screens/glosco/global-conference-session';
import GloscoCohortList from './screens/glosco/manage-cohort';
import GloscoResourcesManage from './screens/glosco/resources';
// import Home from './screens/home';
import WrapMaster from './components/wrapper/main';
// Auth
import Login from './screens/auth/login';
import Logout from "./screens/auth/logout";
import ResetPassword from "./screens/auth/reset-password";
// const loading = (
//     <div className="preloader flex-column justify-content-center align-items-center">
//       <img className="animation__shake" src={logo} alt="IFSPD" height="200" width="200" />
//     </div>
// )
//Public
// const Home = lazy(() => import('./screens/home'));
// const WrapMaster = lazy(() => import('./components/wrapper/main'));
import PrivateRoute from "./routes/private";
import AuthRoute from "./routes/auth";

function App() {
    const dispatch = useDispatch();
    // const getDeviceId = () => {
    //     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    //       var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    //       return v.toString(16);
    //     });
    // }
    useEffect(() => {
        //Check if Device Id Set, if not Set New
        if(!localStorage.getItem("device_id")){
            const deviceID = uuidv4();
            //Dispatch and check if it is available in database
            update_device_data({device_id: deviceID});
            // console.log(deviceID, 'deviceID')
        }
        // else{
        //     console.log('nnnnnnnnnnnn')
        // }
        dispatch(auth_token_update());
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
      
    return (
        <>
        {/* <Suspense fallback={loading}> */}
        <div id="bodyOverlay">
            <LoaderMedium size={65} />
        </div>
        <ReactNotification />
        {/* <Header/> */}
        {/* <Navbar /> */}
        {/* <div className="wrapper" style={{minHeight: '70vh'}}> */}
            {/* <div className="container"> */}
            
            <Router>
                <Routes>
                    <Route path='*' element={<WrapMaster title="Page Not Found"><NotFound/></WrapMaster>}/>
                    {/* Auth: Guest Route */}
                    <Route element={<AuthRoute/>}>
                        <Route exact path='/login' element={<Login/>}/>
                        <Route exact path='/reset-password' element={<ResetPassword/>}/>
                    </Route>
                    {/* Routh For Authenticated User */}
                    <Route element={<PrivateRoute/>}>
                        <Route exact path="/" element={<WrapMaster title="Dashboard"><Dashboard/></WrapMaster>}/>
                        <Route exact path="/manage-students" element={<WrapMaster title="Manage Students"><StudentList/></WrapMaster>}/>
                        <Route exact path="/student/:profile_id" element={<WrapMaster title="Student Portfolio"><StudentPortfolio/></WrapMaster>}/>
                        <Route exact path="/analytics-port" element={<WrapMaster title="Student Analytics"><StudentAnalytics/></WrapMaster>}/>
                        <Route exact path="/manage-fellows" element={<WrapMaster title="Manage Fellows"><FellowList/></WrapMaster>}/>
                        {/* Super Admin & Admin */}
                        <Route exact path="/pinned-students" element={<WrapMaster title="Manage Pinned Students"><StuPinnedList/></WrapMaster>}/>
                        <Route exact path="/manage-enrollments" element={<WrapMaster title="Manage Subscription Validity"><EnrollmentList/></WrapMaster>}/>
                        {/* <Route exact path='/verification' element={<Verification/>}/> */}
                        {/* <Route exact path='/checkout/address' element={<MyAddress/>}/> */}
                        {/* Hub */}
                        <Route exact path="/manage-opportunities" element={<WrapMaster title="Manage Opportunities"><HubList/></WrapMaster>}/>
                        {/* Affiliate */}
                        <Route exact path="/manage-affiliates/list" element={<WrapMaster title="Manage Affiliates"><AffiliateList/></WrapMaster>}/>
                        <Route exact path="/manage-affiliates/request" element={<WrapMaster title="Manage Affiliate Requests"><AffiliatePendingList/></WrapMaster>}/>
                        <Route exact path="/manage-affiliates/settings" element={<WrapMaster title="Manage Commission Settings"><AffiliateSettings/></WrapMaster>}/>
                        {/* Nomination */}
                        <Route exact path="/manage-nominations/list" element={<WrapMaster title="Manage School Nominations"><NominationList/></WrapMaster>}/>
                        {/* Admin Stakeholder */}
                        <Route exact path="/manage-admins" element={<WrapMaster title="Manage Admins"><StakeholderList/></WrapMaster>}/>
                        {/* Glosco */}
                        <Route exact path="/manage-glosco-resources" element={<WrapMaster title="Manage GLOSCO Resources"><GloscoResourcesManage/></WrapMaster>}/>
                        <Route exact path="/manage-glosco-cohort" element={<WrapMaster title="Manage GLOSCO Cohort"><GloscoCohortList/></WrapMaster>}/>
                        <Route exact path="/manage-glosco-requests" element={<WrapMaster title="Manage GLOSCO"><GloscoRequestList/></WrapMaster>}/>
                        <Route exact path="/manage-global-conferences-sessions" element={<WrapMaster title="Manage Global Conferences Sessions"><GlobalConferenceSession/></WrapMaster>}/>
                        <Route exact path="/manage-glosco-grip-sessions" element={<WrapMaster title="Manage GLOSCO GRIP Sessions"><GloscoGripSession/></WrapMaster>}/>
                        <Route exact path="/manage-glosco-level" element={<WrapMaster title="Manage GLOSCO Students Year/Level"><GloscoManageLevel/></WrapMaster>}/>
                    </Route>
                    {/* Public Route */}
                    {/* <Route path='/' element={<PublicRoute/>} /> */}
                    {/* <Route path='/'>
                        <PublicRoute />
                    </Route> */}
                    {/* Public Route */}
                    <Route exact path='/logout' element={<WrapMaster><Logout/></WrapMaster>}/>
                    {/* <Route exact path="/home" element={<WrapMaster><Home/></WrapMaster>}/> */}
                </Routes>
                {/* <PublicRoute /> */}
            </Router>
            
            {/* </div> */}
        {/* </div> */}
        {/* <Footer /> */}
        {/* </Suspense> */}
        </>
    );
}
  
export default App;